import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import './ContentBlocks.css';

const ContentBlockHolder = (props) => (
  <div className={'content-block single'}>
    <div className="container">
      {props.children}
    </div>
  </div>
)

ContentBlockHolder.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(ContentBlockHolder);



// WEBPACK FOOTER //
// ./src/components/ContentBlocks/ContentBlockHolder.js